import MainSlider from "../../components/mainSlider/MainSlider.tsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection.tsx";
import HomeProducts from "./HomeProducts.tsx";
import MostProductCategories from "../../components/MostProductCategories.tsx";
import FooterComp from "../../components/footer/FooterComp.tsx";
import { getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { useUser } from "../../context/UserContext.tsx";

const HomePage = () => {

  const { setUser } = useUser();

  const [scrolled, setScrolled] = useState(false);

  const [retailStatus] = useState(localStorage.getItem('rst'));

  useEffect(() => {

    const handleScroll = () => {
      // Sayfa üst kısmından kaydırılan mesafeyi almak
      const scrollPosition = window.scrollY;

      // Sayfa 100px kaydırıldıysa ve henüz 'scrolled' false ise
      if (scrollPosition > 200 && !scrolled) {
        setScrolled(true); // Sayfa kaydırıldığında sadece bir kez true yapıyoruz
      }
    };

    // Scroll event'ini dinlemeye başla
    window.addEventListener('scroll', handleScroll);

    // Cleanup: component unmount olduğunda event'i temizle
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]); // 'scrolled' state'ini bağımlılık listesine ekledik



  React.useEffect(() => {

    const isAuth24Token = async () => {

      const userString = localStorage.getItem("user");

      const user = JSON.parse(userString ?? "{}");


      try {

        // -- FETCH USER INFO -- //
        if (!user) {
          localStorage.removeItem("user");
          localStorage.removeItem('favoriteProductIds');
          localStorage.removeItem('access-token');
          localStorage.removeItem('basketItems');
        }
        
        const fetchUserInfo = await getFetcher(endpoints.user.getUserByEmail.replace('{email}', user?.email || ''));
        if (fetchUserInfo) {
          setUser(fetchUserInfo.user);

          try {
            const res = await getFetcher(endpoints.settings.getAll);

            if (res.result) {
              if (user) {
                try {
                  const businessPackage = await getFetcher(
                    endpoints.user.getBusinessPackageById.replace(
                      "{id}",
                      user.businessPackageId
                    )

                  );
                  if (businessPackage.result) {
                    if (businessPackage.businessPackage?.id !== "10") {
                      if (retailStatus != "6535")
                        window.location.reload();
                      localStorage.setItem('rst', "6535");
                    } else {
                      if (res.settings.value && retailStatus == "714" || !res.settings.value && retailStatus == "6535")
                        window.location.reload();

                      localStorage.setItem('rst', res.settings.value ? "6535" : "714");
                    }
                  } else {
                    localStorage.setItem('rst', "714");
                    if (retailStatus != "714")
                      return window.location.reload();
                  }
                } catch (error) {
                  if (res.settings.value && retailStatus == "714" || !res.settings.value && retailStatus == "6535")
                    window.location.reload();
                  localStorage.setItem('rst', res.settings.value ? "6535" : "714");
                  console.error("Error fetching favorites:", error);
                }

              } else {
                if (res.settings.value && retailStatus == "714" || !res.settings.value && retailStatus == "6535")
                  window.location.reload();
                localStorage.setItem('rst', res.settings.value ? "6535" : "714");
              }
            } else {
              localStorage.setItem('rst', "714");
              if (retailStatus != "714")
                return window.location.reload();
            }
          } catch (error) {
            console.log(error);
            localStorage.setItem('rst', "714");
            if (retailStatus != "714")
              return window.location.reload();
          }

        } else {
          localStorage.removeItem("user");
          localStorage.removeItem('favoriteProductIds');
          localStorage.removeItem('access-token');
          localStorage.removeItem('basketItems');
          window.location.reload();
        }


      } catch (error) {

        const res = await getFetcher(endpoints.settings.getAll);
        if (res.result) {
          if (res.settings.value && retailStatus == "714" || !res.settings.value && retailStatus == "6535")
            window.location.reload();
          localStorage.setItem('rst', res.settings.value ? "6535" : "714");
        } else {
          if (retailStatus != "714")
            return window.location.reload();
          localStorage.setItem('rst', "714");
        }

        console.error(error);
        localStorage.removeItem("user");
        localStorage.removeItem('favoriteProductIds');
        localStorage.removeItem('access-token');
        localStorage.removeItem('basketItems');
      }
    }

    isAuth24Token();
  }, []);



  return (
    <div className="flex flex-col">

      {/* Header */}

      {/* Main Content */}
      <main className="py-2 min-h-screen relative ">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <MainSlider scrolled={scrolled} />
        {
          scrolled ?
            <>
              <HeroSection />
              <HomeProducts />
              <MostProductCategories />
            </>
            :
            <></>
        }

      </main>

      {
        scrolled ?
          <div className="text-white relative">
            {/* <Footer /> */}
            <FooterComp />
          </div>
          :
          <></>
      }
    </div>
  );
};

export default HomePage;
